import { render, staticRenderFns } from "./CategoriesFormTags.vue?vue&type=template&id=2c7b6eed"
import script from "./CategoriesFormTags.vue?vue&type=script&lang=js"
export * from "./CategoriesFormTags.vue?vue&type=script&lang=js"
import style0 from "./CategoriesFormTags.vue?vue&type=style&index=0&id=2c7b6eed&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7b6eed')) {
      api.createRecord('2c7b6eed', component.options)
    } else {
      api.reload('2c7b6eed', component.options)
    }
    module.hot.accept("./CategoriesFormTags.vue?vue&type=template&id=2c7b6eed", function () {
      api.rerender('2c7b6eed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AccountSetup/CategoriesFormTags.vue"
export default component.exports